import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GridOperatorCapacityTariff from './grid-operator-capacity-tariff';
import GridOperatorCapacityTariffDetail from './grid-operator-capacity-tariff-detail';
import GridOperatorCapacityTariffUpdate from './grid-operator-capacity-tariff-update';
import GridOperatorCapacityTariffDeleteDialog from './grid-operator-capacity-tariff-delete-dialog';

const GridOperatorCapacityTariffRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GridOperatorCapacityTariff />} />
    <Route path="new" element={<GridOperatorCapacityTariffUpdate />} />
    <Route path=":id">
      <Route index element={<GridOperatorCapacityTariffDetail />} />
      <Route path="edit" element={<GridOperatorCapacityTariffUpdate />} />
      <Route path="delete" element={<GridOperatorCapacityTariffDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GridOperatorCapacityTariffRoutes;
